package one.healthium.log_food.ui.camera

import androidx.lifecycle.ViewModelStoreOwner
import com.arkivanov.decompose.ComponentContext
import one.healthium.decompose.viewModelStoreOwner
import one.healthium.profile.ui.food.models.FoodUiModel

class DefaultFoodCameraComponent(
    componentContext: ComponentContext,
    private val onFoodScanned: (List<FoodUiModel>) -> Unit,
    private val onBackClicked: () -> Unit,
) : FoodCameraComponent,
    ComponentContext by componentContext,
    ViewModelStoreOwner by componentContext.viewModelStoreOwner() {

    override fun onFoodScanned(foods: List<FoodUiModel>) {
        onFoodScanned.invoke(foods)
    }

    override fun onBackClicked() {
        onBackClicked.invoke()
    }
}
